export const REMINDER_TYPES = {
  task: { label: 'Task', tone: 'info' },
  follow_up: { label: 'Follow-up', tone: 'warning' },
  scheduled_message: { label: 'WhatsApp Reminder', tone: 'success' },
  email_reminder: { label: 'Email Reminder', tone: 'info' },
  appointment: { label: 'Appointment', tone: 'neutral' },
};

export const REMINDER_STATUS_OPTIONS = [
  { value: 'upcoming', label: 'Upcoming', tone: 'info' },
  { value: 'overdue', label: 'Overdue', tone: 'error' },
  { value: 'completed', label: 'Completed', tone: 'success' },
  { value: 'cancelled', label: 'Cancelled', tone: 'neutral' },
  { value: 'paused', label: 'Paused', tone: 'warning' },
];

export const REMINDER_STATUSES = Object.fromEntries(
  REMINDER_STATUS_OPTIONS.map((s) => [s.value, s]),
);

export const SUMMARY_CARDS = [
  {
    key: 'overdue_count',
    title: 'Overdue',
    accent: '#E0435C',
    iconBg: 'bg-[#FCEAEC] text-[#FF383C]',
    filter: { status: ['overdue'] },
  },
  {
    key: 'today_count',
    title: 'Today',
    accent: '#2F6FED',
    iconBg: 'bg-[#E0EEFB] text-[#2F6FED]',
    filter: { preset: 'today' },
  },
  {
    key: 'tomorrow_count',
    title: 'Tomorrow',
    accent: '#C98A1F',
    iconBg: 'bg-[#FBEFD1] text-[#C98A1F]',
    filter: { preset: 'tomorrow' },
  },
  {
    key: 'this_week_count',
    title: 'This Week',
    accent: '#50AB3D',
    iconBg: 'bg-[#EBF4EA] text-[#50AB3D]',
    filter: { preset: 'this_week' },
  },
  {
    key: 'upcoming_count',
    title: 'Upcoming',
    accent: '#2F6FED',
    iconBg: 'bg-[#E0EEFB] text-[#2F6FED]',
    filter: { status: ['upcoming'] },
  },
  {
    key: 'completed_count',
    title: 'Completed',
    accent: '#3FA34D',
    iconBg: 'bg-[#E3F5E1] text-[#3FA34D]',
    filter: { status: ['completed'] },
  },
];

export const DUPLICATE_ACTIONS = [
  {
    value: 'keep_both',
    label: 'Create another reminder',
    description: 'Keep the existing schedule and add this one.',
  },
  {
    value: 'replace',
    label: 'Overwrite the existing schedule',
    description: 'Replace the upcoming reminder with this import.',
  },
  {
    value: 'skip',
    label: 'Do not import these phones',
    description: 'Leave the existing reminder unchanged.',
  },
];

export const CONFLICT_RESOLUTION_REQUIRED_COPY =
  'Please select a conflict resolution option.';

export const CONFLICT_CONTACT_REQUIRED_COPY =
  'Please select at least one contact.';

export const MISSING_ACTIONS = [
  {
    value: 'keep_missing',
    label: 'Leave their reminders as-is',
    description: 'Contacts from the last import stay scheduled.',
  },
  {
    value: 'cancel_missing',
    label: 'Cancel those active reminders',
    description: 'Stop reminders for contacts missing from this file.',
  },
];

export const IMPORT_JOB_STATUS = {
  pending: { tone: 'info', label: 'Pending' },
  processing: { tone: 'warning', label: 'Processing' },
  running: { tone: 'warning', label: 'Running' },
  completed: { tone: 'success', label: 'Completed' },
  failed: { tone: 'error', label: 'Failed' },
};

export const REMINDER_WIZARD_STEPS = [
  'Template',
  'Download',
  'Upload',
  'Confirm',
];

export const IMPORT_MAX_FILE_BYTES = 10 * 1024 * 1024;
export const IMPORT_ACCEPTED_EXTENSIONS = ['.xlsx', '.csv'];
export const CORE_IMPORT_HEADERS = ['phone', 'name'];
export const PREVIEW_EXPIRED_COPY = 'Preview expired. Upload the file again.';
